<h2 mat-dialog-title>Nieuwe gebruiker toevoegen</h2>
<form [formGroup]="form" (ngSubmit)="save()">
    <mat-dialog-content>
        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Naam</mat-label>
            <input matInput formControlName="name" required />
        </mat-form-field>

        <mat-form-field class="w-100" appearance="fill">
            <mat-label>E-mailadres</mat-label>
            <input matInput formControlName="email" required type="email" />
        </mat-form-field>

        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="role" required>
                <mat-option *ngFor="let role of roles" [value]="role.key">{{ role.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button (click)="close()" mat-button type="button">Annuleren</button>
        <button [disabled]="form.invalid || loading" mat-raised-button color="primary" type="submit">Toevoegen</button>
    </mat-dialog-actions>
</form>
